import { AppAuthEventDetail, dispatchAuthEvent } from 'rest/AuthEvent'
import { useHistory } from 'react-router-dom'
import { useEffect, useRef } from 'react'

const useAuthSuccessCallback = (
  sendOnlySuccessEvent = false
) => {
  const { goBack } = useHistory()

  const appAuthEventDetail = useRef<AppAuthEventDetail>({ success: false })

  const successCallback = (detail: AppAuthEventDetail) => {
    appAuthEventDetail.current = detail
    goBack()
  }

  useEffect(() => {
    return () => {
      if (!sendOnlySuccessEvent || appAuthEventDetail.current.success) {
        dispatchAuthEvent(appAuthEventDetail.current)
      }
    }
  }, [sendOnlySuccessEvent])

  return successCallback
}

export default useAuthSuccessCallback